/**
 * Flatten an HTML fragment to plain text: drop every tag and collapse the
 * whitespace they leave behind. Used wherever rich text authored elsewhere
 * has to render as a plain string (card summaries, meta descriptions, API
 * responses) - never as a sanitizer for HTML that will be rendered as HTML.
 */
export function stripHtml(html: string): string {
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
